import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { THEMES } from '../data/theme';
import { Ic, ICONS } from '../data/icons';
import { loginRequest } from '../api/client';

export default function Login({ setAuth }) {
  const C = THEMES['dark'];
  const navigate = useNavigate();
  const [form, setForm]     = useState({ email:'', password:'' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw]   = useState(false);
  const [statusMsg, setStatusMsg] = useState(null); // pending / rejected

  const set = (k, v) => { setForm(f=>({...f,[k]:v})); setErrors(e=>({...e,[k]:'',general:''})); setStatusMsg(null); };

  const validate = () => {
    const e = {};
    if (!form.email.trim())    e.email    = 'E-posta zorunlu';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Geçerli bir e-posta girin';
    if (!form.password.trim()) e.password = 'Şifre zorunlu';
    setErrors(e);
    return !Object.keys(e).length;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);
    setStatusMsg(null);
    try {
      const data = await loginRequest(form.email, form.password);
      localStorage.setItem('mdm_token', data.token);
      localStorage.setItem('mdm_user', JSON.stringify(data.user));
      setAuth({ token: data.token, user: data.user });
      navigate('/');
    } catch (err) {
      const msg = err.message || '';
      if (msg.includes('onaylanmadı') || msg.includes('Pending')) {
        setStatusMsg({ type:'pending', text:'Hesabınız henüz onaylanmadı. Sistem yöneticisi onaylayana kadar giriş yapamazsınız.' });
      } else if (msg.includes('reddedildi') || msg.includes('Rejected')) {
        setStatusMsg({ type:'rejected', text:'Hesabınız reddedildi. Detay için sistem yöneticisiyle iletişime geçin.' });
      } else {
        setErrors({ general: msg || 'Geçersiz e-posta veya şifre' });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:C.bg, fontFamily:"'DM Sans','Segoe UI',sans-serif", padding:16 }}>
      <div style={{ position:'fixed', top:'-10%', left:'-5%', width:500, height:500, borderRadius:'50%', background:'radial-gradient(circle,rgba(59,130,246,0.08) 0%,transparent 70%)', pointerEvents:'none' }} />
      <div style={{ position:'fixed', bottom:'-10%', right:'-5%', width:600, height:600, borderRadius:'50%', background:'radial-gradient(circle,rgba(139,92,246,0.06) 0%,transparent 70%)', pointerEvents:'none' }} />

      <div style={{ width:'100%', maxWidth:400, position:'relative' }}>
        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <div style={{ width:56, height:56, background:'linear-gradient(135deg,#3b82f6,#8b5cf6)', borderRadius:16, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', boxShadow:'0 8px 24px rgba(59,130,246,0.35)' }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
          </div>
          <div style={{ fontSize:26, fontWeight:900, color:C.text, letterSpacing:'-0.8px' }}>CorpMDM</div>
          <div style={{ fontSize:13, color:C.textFaint, marginTop:4 }}>Cihaz Yönetim Paneli</div>
        </div>

        <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:20, padding:'32px 28px', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
          <div style={{ fontSize:18, fontWeight:800, color:C.text, marginBottom:4, letterSpacing:'-0.4px' }}>Giriş Yap</div>
          <div style={{ fontSize:13, color:C.textFaint, marginBottom:26 }}>Hesabınıza erişmek için giriş yapın</div>

          {/* Genel hata */}
          {errors.general && (
            <div style={{ background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.3)', borderRadius:10, padding:'10px 14px', fontSize:13, color:'#f87171', marginBottom:18, display:'flex', gap:8, alignItems:'center' }}>
              <Ic d={ICONS.alert} size={15} s='#f87171' /> {errors.general}
            </div>
          )}

          {/* Onay bekleniyor */}
          {statusMsg?.type === 'pending' && (
            <div style={{ background:'rgba(245,158,11,0.1)', border:'1px solid rgba(245,158,11,0.3)', borderRadius:10, padding:'14px 16px', marginBottom:18 }}>
              <div style={{ display:'flex', gap:8, alignItems:'center', marginBottom:6 }}>
                <span style={{ fontSize:18 }}>⏳</span>
                <div style={{ fontSize:13.5, fontWeight:700, color:'#fbbf24' }}>Onay Bekleniyor</div>
              </div>
              <div style={{ fontSize:12.5, color:'#fde68a', lineHeight:1.6 }}>{statusMsg.text}</div>
            </div>
          )}

          {/* Hesap reddedildi */}
          {statusMsg?.type === 'rejected' && (
            <div style={{ background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.3)', borderRadius:10, padding:'14px 16px', marginBottom:18 }}>
              <div style={{ display:'flex', gap:8, alignItems:'center', marginBottom:6 }}>
                <span style={{ fontSize:18 }}>❌</span>
                <div style={{ fontSize:13.5, fontWeight:700, color:'#f87171' }}>Hesap Reddedildi</div>
              </div>
              <div style={{ fontSize:12.5, color:'#fca5a5', lineHeight:1.6 }}>{statusMsg.text}</div>
            </div>
          )}

          <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
            {/* E-posta */}
            <div>
              <label style={{ fontSize:11.5, fontWeight:600, color:C.textSub, display:'block', marginBottom:7 }}>E-posta</label>
              <div style={{ display:'flex', alignItems:'center', gap:8, background:C.surface2, border:`1px solid ${errors.email?'#ef4444':C.border}`, borderRadius:10, padding:'0 14px', height:46, transition:'border-color 0.15s' }}
                onFocus={() => {}} onBlur={() => {}}>
                <Ic d={ICONS.mail} size={16} s={C.textFaint} />
                <input type='email' value={form.email} onChange={e=>set('email',e.target.value)} onKeyDown={e=>e.key==='Enter'&&handleSubmit()} placeholder='ornek@sirket.com'
                  style={{ background:'none', border:'none', outline:'none', color:C.text, fontSize:13.5, width:'100%', fontFamily:'inherit' }} />
              </div>
              {errors.email && <div style={{ fontSize:11, color:'#f87171', marginTop:4 }}>{errors.email}</div>}
            </div>
            {/* Şifre */}
            <div>
              <label style={{ fontSize:11.5, fontWeight:600, color:C.textSub, display:'block', marginBottom:7 }}>Şifre</label>
              <div style={{ display:'flex', alignItems:'center', gap:8, background:C.surface2, border:`1px solid ${errors.password?'#ef4444':C.border}`, borderRadius:10, padding:'0 14px', height:46, transition:'border-color 0.15s' }}>
                <Ic d={ICONS.key} size={16} s={C.textFaint} />
                <input type={showPw?'text':'password'} value={form.password} onChange={e=>set('password',e.target.value)} onKeyDown={e=>e.key==='Enter'&&handleSubmit()} placeholder='••••••••'
                  style={{ background:'none', border:'none', outline:'none', color:C.text, fontSize:13.5, width:'100%', fontFamily:'inherit' }} />
                <button type='button' onClick={() => setShowPw(v=>!v)} style={{ background:'none', border:'none', cursor:'pointer', color:C.textFaint, display:'flex' }}>
                  <Ic d={ICONS.eye} size={15} />
                </button>
              </div>
              {errors.password && <div style={{ fontSize:11, color:'#f87171', marginTop:4 }}>{errors.password}</div>}
            </div>
          </div>

          <button onClick={handleSubmit} disabled={loading} style={{ width:'100%', height:46, marginTop:24, borderRadius:12, border:'none', background:'linear-gradient(135deg,#3b82f6,#6366f1)', color:'#fff', fontSize:14, fontWeight:700, cursor:loading?'wait':'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8, opacity:loading?0.8:1, transition:'opacity 0.2s,transform 0.15s' }}
            onMouseEnter={e=>{if(!loading)e.currentTarget.style.transform='translateY(-1px)'}}
            onMouseLeave={e=>e.currentTarget.style.transform='none'}>
            {loading ? 'Giriş yapılıyor...' : <>Giriş Yap <Ic d={ICONS.arrowR} size={16} s='#fff' /></>}
          </button>

          <div style={{ textAlign:'center', marginTop:20, fontSize:12.5, color:C.textFaint }}>
            Hesabınız yok mu?{' '}
            <button onClick={() => navigate('/register')} style={{ background:'none', border:'none', cursor:'pointer', color:C.accent, fontWeight:600, fontSize:12.5 }}>Kayıt Ol</button>
          </div>
        </div>
      </div>
    </div>
  );
}
